// Table.tsx
import React from "react"
import {
  GridRowModel,
  GridColDef,
  GridRowsProp,
  GridColumnVisibilityModel,
  GridSortModel,
  GridCallbackDetails,
  GridRowSelectionModel,
  GridRowParams,
} from "@mui/x-data-grid"
import StyledDataGrid from "./styles"
import CustomNoRowsOverlay from "./CustomNoRowsOverlay"

interface TableProps {
  rows: GridRowsProp
  columns: GridColDef[]
  processRowUpdate?: (newRow: GridRowModel) => Promise<GridRowModel>
  loading: boolean
  rowCount: number
  pageSizeOptions?: number[]
  paginationModel?: any
  paginationMode?: any
  onPaginationModelChange?: (model: any) => void
  disableColumnFilter?: boolean
  onCellClick?: (params: any) => void
  columnVisibilityModel?: GridColumnVisibilityModel | undefined
  sortModel?: GridSortModel | undefined
  onSortModelChange?:
    | ((model: GridSortModel, details: GridCallbackDetails) => void)
    | undefined
  height?: string
  checkboxSelection?: boolean
  disableRowSelectionOnClick?: boolean
  rowSelectionModel?: string[]
  onRowSelectionModelChange?: (
    rowSelectionModel: GridRowSelectionModel,
    details: GridCallbackDetails<any>,
  ) => void
  isRowSelectable?: (params: GridRowParams) => boolean
}

const Table: React.FC<TableProps> = ({
  rows,
  columns,
  processRowUpdate,
  loading,
  rowCount,
  pageSizeOptions,
  paginationModel,
  onPaginationModelChange,
  disableColumnFilter,
  onCellClick,
  paginationMode,
  columnVisibilityModel,
  sortModel,
  onSortModelChange,
  checkboxSelection = false,
  disableRowSelectionOnClick = false,
  rowSelectionModel,
  onRowSelectionModelChange,
  isRowSelectable = () => true,
}) => {
  return (
    <StyledDataGrid
      initialState={{
        columns: {
          columnVisibilityModel,
        },
      }}
      rows={rows}
      columns={columns}
      processRowUpdate={processRowUpdate}
      loading={loading}
      rowCount={rowCount}
      pageSizeOptions={pageSizeOptions}
      paginationModel={paginationModel}
      paginationMode={paginationMode}
      onPaginationModelChange={onPaginationModelChange}
      disableColumnFilter={disableColumnFilter}
      onCellClick={onCellClick}
      slots={{
        noRowsOverlay: CustomNoRowsOverlay,
      }}
      sortingMode="server"
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      checkboxSelection={checkboxSelection}
      getRowId={(row) => row.id}
      disableRowSelectionOnClick={disableRowSelectionOnClick}
      rowSelectionModel={rowSelectionModel}
      onRowSelectionModelChange={onRowSelectionModelChange}
      isRowSelectable={isRowSelectable}
    />
  )
}

export default Table
